import { FormControl, FormLabel, Input, VStack } from "@chakra-ui/react";
import React from "react";

const MainInput = ({
  label,
  error,
  placeholder,
  register,
  name,
  type = "text",
  defaultValues,
  required = true,
}) => {
  return (
    <FormControl isInvalid={Boolean(error)}>
      <VStack align="stretch" spacing={2}>
        {label && (
          <FormLabel
            m={0}
            htmlFor={name}
            fontSize="14px"
            fontWeight="700"
            color="#6A1E1E"
            textAlign="left"
          >
            {label}
          </FormLabel>
        )}
        <Input
          id={name}
          type={type}
          borderColor={error ? "red" : "#D8CEC3"}
          placeholder={placeholder}
          size="md"
          bg="#FAF2EB"
          border="1px solid"
          borderRadius="lg"
          _focus={{
            borderColor: "#6A1E1E",
            boxShadow: "0 0 0 1px rgba(106, 30, 30, 0.22)",
          }}
          defaultValue={defaultValues}
          {...register(name, required ? { required: "هذه المعلومات مطلوبة" } : {})}
        />
      </VStack>
    </FormControl>
  );
};

export default MainInput;